














































import { ParcelasComTaxas, FormPagamento, ParcelasCrediario } from '@/models'
import { maiorOuIgualAZero } from '@/shareds/regras-de-form'
import { Vue, Component, Watch } from 'vue-property-decorator'
import DatePicker from '../ui/DatePicker.vue'

@Component({
	components: {
		DatePicker,
	}})
export default class DialogoDeEdicaoDeParcelas extends Vue {
	formPagamento: FormPagamento = {} as FormPagamento

	mostra = false
	carregando = false
	datas: string[] | [] = []
	parcelasCrediario!: ParcelasCrediario[]
	maiorOuIgualAZero = maiorOuIgualAZero

	confirmarLista() {
		const novasParcelas: ParcelasCrediario[] = this.datas.map((data, index) => ({
			parcela: index + 1,
			vencimento: data,
		} as ParcelasCrediario))
		this.parcelasCrediario = JSON.parse(JSON.stringify(novasParcelas))
		this.$emit('parcelamenteEditado', JSON.parse(JSON.stringify(this.parcelasCrediario)))
		this.mostra = false
	}

	mostrar(formPagamento) {
		this.formPagamento = formPagamento
		if(!this.formPagamento.tipoDePagamento?.parcelasComTaxas) return
		this.calcularDatasParcelas()
		this.mostra = true 
		this.formPagamento.tipoDePagamento.parcelasComTaxas.sort(this.compararPorParcela)
	}

	compararPorParcela(a: ParcelasComTaxas, b: ParcelasComTaxas) {
		return a.parcelamentos - b.parcelamentos;
	}
	
	calcularDatasParcelas() {
		if (!this.formPagamento.qtdeDeParcelas || !this.formPagamento.tipoDePagamento || !this.formPagamento.tipoDePagamento.parcelasComTaxas) {
			return;
		}

		const parcelasComTaxas = this.formPagamento.tipoDePagamento.parcelasComTaxas;
		const qtdeTotalParcelas = this.formPagamento.qtdeDeParcelas;
		const datas: string[] = [];
		let dataAtual = new Date();
		dataAtual.setHours(0, 0, 0, 0);
		const diasBase = Number(this.formPagamento.tipoDePagamento.diasBaseParaFaturamento ?? 0)

		dataAtual.setDate(dataAtual.getDate() + diasBase)
		let parcelasGeradas = 0;

		for (let i = 0; i < parcelasComTaxas.length && parcelasGeradas < qtdeTotalParcelas; i++) {
			const faixa = parcelasComTaxas[i];
			const recorrencia = faixa.recorrencia;
			const quantidade = faixa.parcelamentos;

			for (let j = 0; j < quantidade && parcelasGeradas < qtdeTotalParcelas; j++) {
				dataAtual.setDate(dataAtual.getDate() + recorrencia);
				datas.push(dataAtual.toISOString().split('T')[0]);
				parcelasGeradas++;
			}
		}

		this.datas = datas;
	}

	@Watch('formPagamento.tipoDePagamento', { deep: true })
	onTipoPagamentoChanged() {
		if (!this.mostra) return
		this.calcularDatasParcelas()
	}

}
